import dayjs from "dayjs";
import type { DocumentReference } from "fhir/r5";

export function getBinaryUrl(doc: DocumentReference): string | undefined {
  return doc.content?.[0]?.attachment?.url;
}

export function formatDateLabel(date?: string): string {
  return date ? dayjs(date).format("DD/MM/YYYY") : "";
}

export function sortDocumentsByDateDesc(
  documents: DocumentReference[],
): DocumentReference[] {
  return [...documents].sort((left, right) => {
    const leftTime = left.date && dayjs(left.date).isValid()
      ? dayjs(left.date).valueOf()
      : 0;
    const rightTime = right.date && dayjs(right.date).isValid()
      ? dayjs(right.date).valueOf()
      : 0;
    return rightTime - leftTime;
  });
}
